import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import AutoReportsLogs from '../../components/AutoReports/AutoReportLogs';

// Optional pre-filter: opened from the auto-reports list row actions with ?report-id=<id>
const autoReportLogSearchSchema = z.object({
  'report-id': z.coerce.number().optional().catch(undefined),
});

// No permission gate: matches the original (wouter) router, where /auto-reports/log rendered for
// any logged-in user (no `access` prop). Visibility is controlled by the backend-driven main menu.
export const Route = createFileRoute('/_authenticated/auto-reports/log')({
  validateSearch: autoReportLogSearchSchema,
  beforeLoad: ({ context }) => {
    return {
      ...context,
      documentTitle: {
        main: 'tab.auto-report/log',
        suffix: 'menu.autoReports',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AutoReportLogsRoute,
});

function AutoReportLogsRoute() {
  return <AutoReportsLogs />;
}
